import React from 'react'
import NavMenuItem from './NavMenuItem'
import {
  NavItem,
  INavItemListProps,
} from '../../../interfaces/Navigation.Interface'

const SecondaryNavItemsList = ({ navItems, id }: INavItemListProps) => (
  <ul>
    {navItems.map((item: NavItem, index) => {
      return (
        <React.Fragment key={`${id}-${index}`}>
          <NavMenuItem key={index} {...item}></NavMenuItem>
          {index < navItems.length - 1 ? '' : ''}
        </React.Fragment>
      )
    })}
  </ul>
)

export default SecondaryNavItemsList
